// shotService.js

export const predefinedShots = [
    { category: 'Roof Inspections', label: 'Full Roof Overview – Top Down' },
    { category: 'Roof Inspections', label: 'Chimney and Vent Close-up' },
    { category: 'Roof Inspections', label: 'Eaves and Gutters – Edge View' },
    { category: 'Roof Inspections', label: 'Suspected Damage Areas – Close-up' },
    { category: 'Roof Inspections', label: 'Thermal Analysis – Top Down' },
    { category: 'Roof Inspections', label: 'Skylight Inspections – 45-Degree Angle' },
    { category: 'Surveying', label: 'Grid Mapping – 80% Overlap' },
    { category: 'Surveying', label: 'Elevation Marker Reference Point – Top Down' },
    { category: 'Surveying', label: 'Panoramic View – Northeast Quadrant' },
    { category: 'Surveying', label: 'Detailed Terrain Features – Oblique Angle' },
    { category: 'Surveying', label: 'Key Intersection Points – Top Down' },
    { category: 'Mapping', label: 'Full Area Orthogonal – Grid Pattern' },
    { category: 'Mapping', label: 'Ground Control Point – Close-up' },
    { category: 'Mapping', label: 'Oblique View of Terrain' },
    { category: 'Mapping', label: 'POI: Bridge Structure – 45-Degree Angle' },
    { category: 'Real Estate', label: 'Front Exterior – Low Altitude' },
    { category: 'Real Estate', label: 'Rear Property Line – Flyover' },
    { category: 'Real Estate', label: 'Pool and Garden – Close-up' },
    { category: 'Real Estate', label: 'Neighborhood Context – High Altitude' },
    { category: 'Real Estate', label: 'Golden Hour Front View – Top Down' },
    { category: 'Real Estate', label: 'Circular Orbit Around Property' },
    { category: 'Lighthouse Aerials', label: 'Full Lighthouse Flyover – Top Down' },
    { category: 'Lighthouse Aerials', label: '360-Degree Orbit – Mid-Level' },
    { category: 'Lighthouse Aerials', label: 'Low Altitude Pass – Front View' },
    { category: 'Lighthouse Aerials', label: 'Wide Angle – Coastal Context' },
    { category: 'Lighthouse Aerials', label: 'Close-Up of Light Fixture' },
    { category: 'Lighthouse Aerials', label: 'Ascending Shot – Base to Top' },
    { category: 'Lighthouse Aerials', label: 'Descending Shot – Top to Base' },
];